import { useMemo } from 'react';
import { useUI } from '../contexts';
import { TreeNode } from '../types';

type UseGoToResultsParams = {
  fileList: TreeNode[];
};

export function useGoToResults({ fileList }: UseGoToResultsParams) {
  const { goToQuery } = useUI();

  const goToResults = useMemo(() => {
    const q = goToQuery.trim().toLowerCase();
    const list = !q
      ? fileList
      : fileList.filter((node) => node.name.toLowerCase().includes(q) || node.path.toLowerCase().includes(q));
    return list.slice(0, 50);
  }, [fileList, goToQuery]);

  return { goToResults };
}
